import { KeyFrame } from "./KeyFrame";

export class KeyFramesHolder{
    
    private holder : Map<number, KeyFrame> = new Map()
    private maxKeyFrame = 0;
    private recentPrevious = 0;
    private recentNext = 0;

    add(key: number, value: KeyFrame){
        this.holder.set(key, value);
        if(key > this.maxKeyFrame){
            this.maxKeyFrame = key;
        }
        this.computeNeighbors(key);
    }

    remove(key: number){
        if(this.holder.delete(key)){
            if(this.maxKeyFrame == key){
                this.computeMaxKeyFrame();
            }
        }
        this.computeNeighbors(key);
    }

    get(key: number): KeyFrame | undefined{
        if(this.contains(key)){
            return this.holder.get(key);
        }
        return undefined;
    }

    clearAllExceptFirst(){
        var first = this.get(0)
        if(first != undefined){
            this.holder.clear()
            this.add(0, first)
            this.computeMaxKeyFrame();
        }else{
            console.log("First Key Frame undefined!!!")
        }
    }

    /**
     * Method to fetch the prev key frame of a given frame
     * If given frame is a key frame, then it will be returned.
     * @param key for which prev needs to be fetched
     */
    getPrev(key: number): KeyFrame | undefined{
        if(key >= this.recentPrevious && key <= this.recentNext){
            //do nothing
        }else{
            this.computeNeighbors(key);
        }
        return this.holder.get(this.recentPrevious);
    }

    /**
     * Method to fetch the next key frame of a given frame
     * If given frame is a key frame, then it will be returned.
     * @param key for which next needs to be fetched
     */
    getNext(key: number): KeyFrame | undefined{
        if(key >= this.recentPrevious && key <= this.recentNext){
            //do nothing
        }else{
            this.computeNeighbors(key);
        }
        return this.holder.get(this.recentNext);
    }

    size(): number{
        return this.holder.size;
    }

    getMaxKeyFrame(): number{
        return this.maxKeyFrame;
    }

    contains(key: number): boolean{
        return this.holder.has(key);
    }

    getKeys(): IterableIterator<number>{
        return this.holder.keys();
    }

    printKeys(){
        var s = "";
        for(var key of this.holder.keys()){
            s = s + key + ",";
        }
        console.log("Size:"+this.holder.size+" Keys:"+s);
    }

    private computeMaxKeyFrame(){
        var max = 0;
        for(var key of this.holder.keys()){
            if(key > max){
                max = key;
            }
        }
        this.maxKeyFrame = max;
    }

    /**
     * Method to compute the next and previous key frames of a given frame
     * Special cases:
     *      Prev(0) = 0
     *      Next(max) = max
     *      Next(number greater than max) = max
     * @param searchKey the frame number for which neighbors need to be found
     */
    private computeNeighbors(searchKey: number){
        var prev = 0;
        var next = 0;
        if(searchKey >= this.maxKeyFrame){
            next = this.maxKeyFrame;
        }
        for(var key of this.holder.keys()){
            if(searchKey > key && key > prev){
                prev = key;
            }
            if(searchKey < key){
                if(next == 0 || key < next){
                    next = key;
                }
            }
        }
        this.recentNext = next;
        this.recentPrevious = prev;
    }
}